import { useSetRecoilState } from "recoil";
import { ArrowsUp } from "../../constants/Svgs";
import styled from "styled-components";
import { plansModalState } from "../../recoil/modal";

export default function UpgradeButton() {
  const setPlansModalState = useSetRecoilState(plansModalState);
  return (
    <Container
      onClick={() => {
        setPlansModalState(true);
      }}
    >
      <ArrowsUp />
      Upgrade
    </Container>
  );
}

const Container = styled.div`
  padding: 0.3125rem 0.5625rem;
  background-color: #2383e2;
  border-radius: 0.125rem;
  font-size: 0.625rem;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s;

  svg {
    margin-right: 0.3125rem;
  }

  &:hover {
    background-color: #1e6ab3;
  }
`;
